export default __webpack_public_path__ + "static/media/map-loading-placeholder.8dbc0c21.jpg";